(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["core-2-product-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
  const wrap = document.querySelector("[data-intro-tab]");
  if (!wrap) return;

  /* ===========================
      入场动画
  =========================== */
  let resizeTimerAos = null;
  let roAos = null;

  function viewportMidY() {
    return window.innerHeight * 0.5;
  }

  function updateAosAnimate() {
    const rect = wrap.getBoundingClientRect();
    const mid = viewportMidY();
    const triggerPoint = window.innerHeight * 0.1;
    const centerLineInside = rect.top <= mid && rect.bottom >= triggerPoint;
    wrap.classList.toggle("animate", centerLineInside);
  }

  function handleResizeAos() {
    clearTimeout(resizeTimerAos);
    resizeTimerAos = setTimeout(updateAosAnimate, 80);
  }

  updateAosAnimate();
  window.addEventListener("scroll", updateAosAnimate, { passive: true });
  window.addEventListener("resize", handleResizeAos);
  if (window.ResizeObserver) {
    roAos = new ResizeObserver(updateAosAnimate);
    roAos.observe(wrap);
  }

  /* ===========================
      全局DOM
  =========================== */
  const textPanels = wrap.querySelectorAll(".core-2-product-intro__text-panel");
  const mediaPanels = wrap.querySelectorAll(".core-2-product-intro__media-panel");
  const tagBtns = wrap.querySelectorAll(".core-2-product-intro__tag-btn");
  const tagImages = wrap.querySelectorAll(".core-2-product-intro__tag-img");
  const slideIndicator = wrap.querySelector(".core-2-product-intro__slide-indicator");

  // Tab内标签轮播
  let autoTagTimer = null;
  const AUTO_TAG_DELAY = 1400;
  // 主Tab自动轮播
  let mainTabTimer = null;
  const MAIN_TAB_DELAY = 5000;
  let currentMainIdx = 0;
  const totalMainTab = textPanels.length;

  /* ===========================
      左侧指示条更新
  =========================== */
  function updateSlideIndicator(panel) {
    if (!slideIndicator || !panel) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          slideIndicator.style.transform = `translateY(${panel.offsetTop}px)`;
          slideIndicator.style.height = `${panel.offsetHeight}px`;
        }, 50)
      });
    });
  }

  /* ===========================
      主Tab切换逻辑
  =========================== */
  function switchMainTab(index) {
    currentMainIdx = Number(index);
    let activePanel = null;

    textPanels.forEach(panel => {
      const active = Number(panel.dataset.tabIndex) === index;
      panel.classList.toggle("active", active);
      if (active) activePanel = panel;
    });

    mediaPanels.forEach(panel => {
      panel.classList.toggle("active", Number(panel.dataset.mediaTab) === index);
    });

    updateSlideIndicator(activePanel);

    const desc = activePanel?.querySelector(".core-2-product-intro__desc");
    if (desc) {
      desc.addEventListener("transitionend", () => updateSlideIndicator(activePanel), { once: true });
    }

    // 切到Tab2启动标签自动轮播，切回Tab1停止
    if (index === 1) {
      switchTag(0);
      startAutoTagLoop();
    } else {
      clearInterval(autoTagTimer);
    }
  }

  // 主Tab自动循环
  function autoMainTabSwitch() {
    if (totalMainTab <= 1) return;
    let next = currentMainIdx + 1;
    if (next >= totalMainTab) next = 0;
    switchMainTab(next);
  }

  function startMainTabAutoPlay() {
    clearInterval(mainTabTimer);
    mainTabTimer = setInterval(autoMainTabSwitch, MAIN_TAB_DELAY);
  }

  function stopMainTabAutoPlay() {
    clearInterval(mainTabTimer);
  }

  /* ===========================
      Tag按钮切换（保留原有自动逻辑）
  =========================== */
  function switchTag(index) {
    tagBtns.forEach(btn => {
      btn.classList.toggle("active", Number(btn.dataset.tagIndex) === index);
    });
    tagImages.forEach(img => {
      img.classList.toggle("show", Number(img.dataset.tagIndex) === index);
    });
  }

  function startAutoTagLoop() {
    clearInterval(autoTagTimer);
    if (!tagBtns.length) return;
    autoTagTimer = setInterval(() => {
      let current = 0;
      tagBtns.forEach(btn => {
        if (btn.classList.contains("active")) current = Number(btn.dataset.tagIndex);
      });
      const next = (current + 1) % tagBtns.length;
      switchTag(next);
    }, AUTO_TAG_DELAY);
  }

  /* ===========================
      点击绑定
  =========================== */
  // 主Tab面板点击，重置主Tab倒计时
  textPanels.forEach(panel => {
    panel.addEventListener("click", () => {
      const idx = Number(panel.dataset.tabIndex);
      switchMainTab(idx);
      stopMainTabAutoPlay();
      startMainTabAutoPlay();
    });
  });

  // Tag按钮点击，重置标签自动轮播
  tagBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      const idx = Number(btn.dataset.tagIndex);
      switchTag(idx);
      startAutoTagLoop();
    });
  });

  /* ===========================
      初始化
  =========================== */
  switchMainTab(0);
  startMainTabAutoPlay();
  if (tagBtns.length) {
    switchTag(0);
    startAutoTagLoop();
  }

  /* ===========================
      窗口缩放更新指示条
  =========================== */
  window.addEventListener("resize", () => {
    const active = wrap.querySelector(".core-2-product-intro__text-panel.active");
    updateSlideIndicator(active);
  });

  /* ===========================
      Shopify区块卸载销毁定时器
  =========================== */
  document.addEventListener("shopify:section:unload", () => {
    window.removeEventListener("scroll", updateAosAnimate);
    window.removeEventListener("resize", handleResizeAos);
    clearTimeout(resizeTimerAos);
    clearInterval(autoTagTimer);
    clearInterval(mainTabTimer);
    if (roAos) roAos.disconnect();
  }, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-in-the-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  const el = document.querySelector('[data-plp-inbox]');
  if (!el) return;

  let resizeTimer = null;
  let ro = null;

  // 视口阈值，和其余PLP组件完全统一
  function viewportMidY() {
    return window.innerHeight * 0.6;
  }

  // 更新动画激活状态
  function updateAosAnimate() {
    const rect = el.getBoundingClientRect();
    const mid = viewportMidY();
    const triggerPoint = window.innerHeight * 0.1;
    const centerLineInside = rect.top <= mid && rect.bottom >= triggerPoint;
    el.classList.toggle('animate', centerLineInside);
  }

  // 防抖resize
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAosAnimate, 80);
  }

  // 初始执行
  updateAosAnimate();

  // 监听滚动、窗口缩放
  window.addEventListener('scroll', updateAosAnimate, { passive: true });
  window.addEventListener('resize', handleResize);

  // 元素尺寸监听
  if (window.ResizeObserver) {
    ro = new ResizeObserver(updateAosAnimate);
    ro.observe(el);
  }

  // Shopify区块卸载，统一销毁监听，防止内存泄漏
  document.addEventListener('shopify:section:unload', function() {
    window.removeEventListener('scroll', updateAosAnimate);
    window.removeEventListener('resize', handleResize);
    clearTimeout(resizeTimer);
    if (ro) ro.disconnect();
  }, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-picture-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  const el = document.querySelector('[data-plp-picture-text]');
  if (!el) return;

  let resizeTimer = null;
  let ro = null;

  // 触发条件：区块垂直中点到达视口垂直中点时激活动画
  function updateAosAnimate() {
    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    // 元素中心点Y坐标
    const elementCenterY = rect.top + rect.height / 2;
    // 视口中心点Y坐标
    const viewportCenterY = viewportHeight / 2;
    // 元素中点进入视口中点即触发动画
    const triggerActive = rect.top <= viewportHeight * 0.5;
    el.classList.toggle('animate', triggerActive);
  }

  // 窗口防抖更新
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAosAnimate, 80);
  }

  // 页面载入初始化
  updateAosAnimate();

  // 滚动、窗口缩放监听
  window.addEventListener('scroll', updateAosAnimate, { passive: true });
  window.addEventListener('resize', handleResize);

  // 元素尺寸变化监听
  if (window.ResizeObserver) {
    ro = new ResizeObserver(updateAosAnimate);
    ro.observe(el);
  }

  // Shopify区块卸载销毁监听，避免内存泄漏
  document.addEventListener('shopify:section:unload', function() {
    window.removeEventListener('scroll', updateAosAnimate);
    window.removeEventListener('resize', handleResize);
    clearTimeout(resizeTimer);
    if (ro) ro.disconnect();
  }, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-scene-swiper"] && !Shopify.designMode) return;
  try {
    
(function () {
  const wrap = document.querySelector('[data-plp-scene-swiper]');
  if (!wrap) return;

  let resizeTimerAos = null;
  let roAos = null;
  let autoTimer = null; // 自动轮播定时器

  const swiperBox = wrap.querySelector('.plp-scene-swiper__swiper');
  const slides = wrap.querySelectorAll('.plp-scene-swiper__slide');
  const tabs = wrap.querySelectorAll('.plp-scene-swiper__tab-item');
  const tabSlider = wrap.querySelector('.plp-scene-tab-slider');
  const contentItems = wrap.querySelectorAll('.plp-scene-swiper__content');
  const descItems = wrap.querySelectorAll('.plp-scene-swiper__desc');
  const contentsWrap = wrap.querySelector('.plp-scene-swiper__contents-wrap');
  const slideCount = slides.length;
  let currentIndex = 0;
  let touchStartX = 0;
  let touchEndX = 0;
  const AUTO_DELAY = 5000; // 5秒自动切换间隔

  // 更新滑块位置宽度核心函数
  function updateTabSlider(targetTab) {
    if(!targetTab || !tabSlider) return;
    const containerRect = targetTab.parentElement.getBoundingClientRect();
    const tabRect = targetTab.getBoundingClientRect();
    const offsetX = tabRect.left - containerRect.left;
    tabSlider.style.width = `${tabRect.width}px`;
    tabSlider.style.transform = `translateX(${offsetX}px)`;
  }

  // 入场动画
  function viewportMidY() {
    return window.innerHeight * 0.9;
  }
  function updateAosAnimate() {
    const rect = wrap.getBoundingClientRect();
    const mid = viewportMidY();
    const triggerPoint = window.innerHeight * 0.1;
    const centerLineInside = rect.top <= mid && rect.bottom >= triggerPoint;
    wrap.classList.toggle('animate', centerLineInside);
  }
  function handleResizeAos() {
    clearTimeout(resizeTimerAos);
    resizeTimerAos = setTimeout(updateAosAnimate, 80);
  }

  // 文案高度自适应
  function setMaxDescHeight() {
    let maxDescHeight = 0;
    contentItems.forEach(item => item.style.opacity = '1');
    descItems.forEach(desc => {
      const h = desc.offsetHeight;
      if (h > maxDescHeight) maxDescHeight = h;
    });
    contentItems.forEach((item, idx) => {
      item.style.opacity = '';
      item.classList.toggle('active', idx === currentIndex);
    });
    const titleEl = contentItems[0]?.querySelector('.plp-scene-swiper__title');
    if(!titleEl) return;
    const titleMargin = parseFloat(getComputedStyle(titleEl).marginBottom);
    const titleHeight = titleEl.offsetHeight;
    const totalWrapHeight = titleHeight + titleMargin + maxDescHeight;
    contentsWrap.style.height = `${totalWrapHeight}px`;
  }

  // 启动自动轮播
  function startAutoPlay() {
    clearTimeout(autoTimer);
    autoTimer = setTimeout(() => {
      let next = currentIndex + 1;
      if(next >= slideCount) next = 0;
      switchTo(next);
    }, AUTO_DELAY);
  }

  // 切换统一入口（渐变切换图片，取消横向translate）
  function switchTo(index) {
    if (index < 0) index = 0;
    if (index >= slideCount) index = slideCount - 1;
    currentIndex = index;
    const activeTab = tabs[index];

    // 图片渐变切换，不再横向滑动
    slides.forEach((slide, idx) => {
      slide.classList.toggle('active', idx === currentIndex);
    });

    tabs.forEach((tab, idx) => {
      tab.classList.toggle('active', idx === currentIndex);
    });

    contentItems.forEach((content, idx) => {
      content.classList.toggle('active', idx === currentIndex);
    });

    // 更新白色滑块
    updateTabSlider(activeTab);

    // 手动切换后重置自动计时
    startAutoPlay();
  }

  // 点击tab切换
  tabs.forEach((tab, idx) => {
    tab.addEventListener('click', () => switchTo(idx));
  });

  // 触摸左右滑动切换
  swiperBox.addEventListener('touchstart', e => {
    touchStartX = e.changedTouches[0].screenX;
  });
  swiperBox.addEventListener('touchend', e => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });
  function handleSwipe() {
    const diff = touchStartX - touchEndX;
    if (diff > 50) switchTo(currentIndex + 1);
    if (diff < -50) switchTo(currentIndex - 1);
  }

  // DOM加载完成立刻初始化滑块
  function initSlider() {
    setMaxDescHeight();
    const initTab = wrap.querySelector('.plp-scene-swiper__tab-item.active');
    if(initTab) updateTabSlider(initTab);
    // 初始化开启自动轮播
    startAutoPlay();
  }
  if(document.readyState === "loading") {
    document.addEventListener('DOMContentLoaded', initSlider);
  } else {
    initSlider();
  }

  // 窗口缩放同步更新滑块
  window.addEventListener('resize', () => {
    setMaxDescHeight();
    const currentTab = wrap.querySelector('.plp-scene-swiper__tab-item.active');
    if(currentTab) updateTabSlider(currentTab);
  });

  // 入场动画监听
  updateAosAnimate();
  window.addEventListener('scroll', updateAosAnimate, { passive: true });
  window.addEventListener('resize', handleResizeAos);
  if (window.ResizeObserver) {
    roAos = new ResizeObserver(updateAosAnimate);
    roAos.observe(wrap);
  }

  // 区块卸载销毁监听
  document.addEventListener('shopify:section:unload', function() {
    window.removeEventListener('scroll', updateAosAnimate);
    window.removeEventListener('resize', handleResizeAos);
    clearTimeout(resizeTimerAos);
    clearTimeout(autoTimer); // 销毁自动轮播定时器
    if (roAos) roAos.disconnect();
    window.removeEventListener('resize', setMaxDescHeight);
  }, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["run2-nordic-design"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const rootEl = document.querySelector('.run2-nordic-design-section .run2-nordic-design');
  if (!rootEl) return;
  const tagEl = rootEl.querySelector('.run2-nordic-design__tag');
  const titleEl = rootEl.querySelector('.run2-nordic-design__title');
  const descEl = rootEl.querySelector('.run2-nordic-design__desc');
  const videoEl = rootEl.querySelector('.run2-nordic-design__video');

  const elements = [
    {
      el: tagEl,
      cls: 'run2-nordic-design__tag--animate',
      threshold: 0.2
    },
    {
      el: titleEl,
      cls: 'run2-nordic-design__title--animate',
      threshold: 0.25
    },
    {
      el: descEl,
      cls: 'run2-nordic-design__desc--animate',
      threshold: 0.3
    },
    {
      el: videoEl,
      cls: 'run2-nordic-design__video--animate',
      threshold: 0.5
    }
  ];

  // 进入视口添加动画，向下滚动离开保留动画类
  elements.forEach(item => {
    if (!item.el) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          item.el.classList.add(item.cls);
        }
      });
    }, { threshold: item.threshold });
    observer.observe(item.el);
  });

  let lastScrollY = window.scrollY;
  // 仅向上滚动、模块整体滚出屏幕上方时移除动画类
  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY < lastScrollY) {
      const rootRect = rootEl.getBoundingClientRect();
      if (rootRect.top - window.innerHeight > 0) {
        elements.forEach(item => {
          if (item.el) {
            item.el.classList.remove(item.cls);
          }
        });
      }
    }
    lastScrollY = currentScrollY;
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["run2-upgraded"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const rootEl = document.querySelector('.run2-upgraded-section .run2-upgraded');
  if (!rootEl) return;

  const tagEl = rootEl.querySelector('.run2-upgraded__tag');
  const titleEl = rootEl.querySelector('.run2-upgraded__title');
  const imageEl = rootEl.querySelector('.run2-upgraded__content-image');

  const elements = [
    {
      el: tagEl,
      cls: 'run2-upgraded__tag--animate'
    },
    {
      el: titleEl,
      cls: 'run2-upgraded__title--animate'
    },
    {
      el: imageEl,
      cls: 'run2-upgraded__content-image--animate'
    }
  ];


  // 进入视口添加动画
  elements.forEach(item => {
    if (!item.el) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          item.el.classList.add(item.cls);
        }
      });
    }, {
      threshold: item.el === imageEl ? 0.5 : 0.2
    });

    observer.observe(item.el);
  });


  let lastScrollY = window.scrollY;


  // 向上滚动离开模块顶部时删除
  window.addEventListener('scroll', () => {

    const currentScrollY = window.scrollY;

    // 只处理向上滚动
    if (currentScrollY < lastScrollY) {

      const rootRect = rootEl.getBoundingClientRect();

      // 模块顶部已经滚出屏幕
      if (rootRect.top - window.innerHeight > 0) {

        elements.forEach(item => {
          if (item.el) {
            item.el.classList.remove(item.cls);
          }
        });

      }
    }

    lastScrollY = currentScrollY;

  }, {
    passive: true
  });

});

  } catch(e) { console.error(e); }
})();
})();
